import { ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { CodeBookExtended } from "../../models/CodeBook";
import { ProgramTypeCodeBook } from "../../models/Program/ProgramTypeCodeBook";
import { ProgramTypeEditCodeBook } from "../../models/Program/ProgramTypeEditCodeBook";

const programTypeUrlPrefix: string = "program-types";

export const getProgramTypes = async () => {
  let result = await api.get(
    `${programTypeUrlPrefix}/detail`
  ) as ProgramTypeCodeBook[];
  setDatesProgramTypes(result);
  return result;
}

export const getProgramTypeById = async (id: number) => {
  let result = await api.get(
    `${programTypeUrlPrefix}/${id}`
  ) as CodeBookExtended;
  setDatesProgramType(result);
  return result
}

export const exportProgramTypes = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${programTypeUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}

export const createProgramType = async (request: ProgramTypeEditCodeBook) => {
  return api.post(
    `${programTypeUrlPrefix}`,
    request
  ) as Promise<number>
}

export const editProgramType = async (id: number, request: ProgramTypeEditCodeBook) => {
  return api.put(
    `${programTypeUrlPrefix}/${id}`,
    request
  ) as Promise<void>
}

export const deleteProgramType = async (id: number) => {
  return api.delete(
    `${programTypeUrlPrefix}/${id}`
  ) as Promise<void>
}

export const getActiveProgramTypes = async (date?: Date) => {
  let url = `${programTypeUrlPrefix}/active`
  if (date) {
    url += `?date=${date.toISOString()}`;
  }
  return api.get(
    url
  ) as Promise<ProgramTypeCodeBook[]>
}

const setDatesProgramTypes = (items: CodeBookExtended[]) => {
  for (let item of items) {
    setDatesProgramType(item);
  }
}

const setDatesProgramType = (item: CodeBookExtended) => {
  if (item.dateTo) {
    item.dateTo = new Date(item.dateTo);
  }
}